import makeStyles from '@mui/styles/makeStyles'

// The default card's cap, in px. Rails and grids size their slots from it.
export const CONTENT_CARD_WIDTH = 282

const getSize = (size, rem) => {
  switch (size) {
    case 'fullWidth':
      return { maxWidth: '100%' }
    case 'large':
      return { maxWidth: rem(384) }
    case 'mobile':
      return { maxWidth: rem(327) }
    default:
      return { maxWidth: rem(CONTENT_CARD_WIDTH) }
  }
}

export const useStyles = makeStyles(({ typography }) => ({
  // `fullWidth` opts the card into the horizontal row layout where the
  // image sits next to the summary; clamping the whole card to the
  // size-based max-width would clip the image against the card edge,
  // so the card spans its parent and lets the inner flex distribute.
  root: ({ size, fullWidth }) =>
    fullWidth ? { maxWidth: '100%' } : getSize(size, typography.pxToRem),
  title: ({ size }) => size === 'large' && typography.heading.h4
}))
